/**
 * **문장마다 한 줄** — 안내 한 칸에 문장이 둘 이상이면 문장마다 줄을 새로 시작하게 나눈다(콜팝 가입·서류 화면 줄바꿈, 2026-10-30 사용자
 * 「개행을 신경써서 깔끔하게」). 문장 끝(`.`·`?`·`!`) 뒤에 빈칸이 올 때만 나눈다 — `1.5`·`ordern.co.kr` 처럼 빈칸 없는 점은 그대로다.
 * 나눈 줄을 빈칸 하나로 다시 이으면 원문이 된다(글자가 바뀌지 않는다). 의존성 없는 순수 모듈이다.
 *
 * @param {?string} text 번역을 마친 글자
 * @returns {Array<string>} 비었으면 빈 배열
 */
export function sentenceLinesOf(text) {
  const source = typeof text === 'string' ? text.trim() : ''
  if (!source) return []

  // 나눈 조각 사이에 문장 끝 부호가 끼어 온다 — [문장, 부호, 문장, 부호, …, 마지막 문장]
  const parts = source.split(/([.?!])\s+/)
  const lines = []
  for (let index = 0; index < parts.length; index += 2) {
    lines.push(parts[index] + (parts[index + 1] || ''))
  }
  return lines
}
